import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36a383ee&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a383ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdSdm/sdSdmAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36a383ee')) {
      api.createRecord('36a383ee', component.options)
    } else {
      api.reload('36a383ee', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36a383ee&scoped=true&", function () {
      api.rerender('36a383ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/goods/goodsCategory/index.vue"
export default component.exports